import { useTranslation } from '@/components/translation';
import { FC, ReactElement } from 'react';
import { StatusTag } from '@digital-pulse/react';

import styles from './preference-status-tag.module.scss';

interface Props {
  enrolledStatus: boolean;
  label?: string;
}

const PreferenceStatusTag: FC<Props> = ({ enrolledStatus, label }): ReactElement => {
  const preferenceOnLabel = useTranslation('preference.status.on.label');
  const preferenceOffLabel = useTranslation('preference.status.off.label');

  return (
    <div>
      <StatusTag
        variant={enrolledStatus ? 'positive' : 'neutral'}
        label={enrolledStatus ? preferenceOnLabel : preferenceOffLabel}
        hasIcon={false}
      />
      <span className={styles.statusTagLabel}>{label}</span>
    </div>
  );
};

export default PreferenceStatusTag;
